import { IAPIDataObject } from '@shared/interfaces/api.interface';
import { IJob } from '@shared/interfaces/job.interface';
import { HiringFirm } from '@shared/models/hiring-firm.model';
import { QuestionSet } from '@shared/models/question-set.model';

export const buildJob = (
  job: IJob,
  relationships: any,
  included: any
): IJob => {
  if (relationships.hiring_firm) {
    if (relationships.hiring_firm.attributes && relationships.hiring_firm.type) {
      job.hiring_firm = HiringFirm.fromAPI({
        data: relationships.hiring_firm,
        included
      });
    } else {
      const hiringFirmId = relationships.hiring_firm.data?.id || relationships.hiring_firm.id;
      const hiringFirm =
        included &&
        included.find(
          (i: IAPIDataObject) => i.id === hiringFirmId
        );

      if (hiringFirm) {
        job.hiring_firm = HiringFirm.fromAPI({
          data: hiringFirm,
          included
        });
      }
    }
  }

  if (relationships.question_set) {
    if (relationships.question_set.attributes && relationships.question_set.type) {
      job.question_set = QuestionSet.fromAPI({
        data: relationships.question_set,
        included
      });
    } else {
      const questionSetId = relationships.question_set.data?.id || relationships.question_set.id;
      const questionSet =
        included &&
        included.find(
          (i: IAPIDataObject) => i.id === questionSetId
        );

      if (questionSet) {
        job.question_set = QuestionSet.fromAPI({
          data: questionSet,
          included
        });
      }
    }
  }

  return job;
};
